import React from "react";

import FeatureDneMarker from "@/components/utilities/FeatureDneMarker";

const FEATURE_DNE_RE = /feature dne/gi;

/**
 * Scan a string for the literal "FEATURE DNE" marker (case-insensitive)
 * and return a React node where each match is wrapped in
 * <FeatureDneMarker>. If no match, the original string is returned
 * untouched so call sites can use this as a drop-in transform.
 *
 * The matched substring keeps its author casing — `Feature Dne` stays
 * `Feature Dne` inside the highlight, not normalized to upper.
 */
export function highlightFeatureDne(input: unknown): React.ReactNode {
  if (typeof input !== "string" || input.length === 0) return input as React.ReactNode;
  if (!FEATURE_DNE_RE.test(input)) return input;
  // Reset the regex's lastIndex since we used `.test()` above on a
  // global-flagged pattern, otherwise `matchAll` would skip ahead.
  FEATURE_DNE_RE.lastIndex = 0;

  const parts: React.ReactNode[] = [];
  let cursor = 0;
  let i = 0;
  for (const match of input.matchAll(FEATURE_DNE_RE)) {
    const start = match.index ?? 0;
    if (start > cursor) parts.push(input.slice(cursor, start));
    parts.push(
      <FeatureDneMarker key={`dne-${i++}`}>{match[0]}</FeatureDneMarker>
    );
    cursor = start + match[0].length;
  }
  if (cursor < input.length) parts.push(input.slice(cursor));
  return <>{parts}</>;
}
